// extracted by mini-css-extract-plugin
export default {"Activate":"Activate_Activate__ItnYp"};